import { render } from "./SourcesModal.vue?vue&type=template&id=592aeb48&scoped=true"
import script from "./SourcesModal.vue?vue&type=script&lang=js"
export * from "./SourcesModal.vue?vue&type=script&lang=js"

import "./SourcesModal.vue?vue&type=style&index=0&id=592aeb48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592aeb48"]])

export default __exports__